/* eslint-disable no-unused-vars */
import { call, put, select, takeEvery } from "redux-saga/effects";
import { errorActions } from "Features/error";
import { api } from "Shared/axios";
import { getReqHeader, getReqHeaderFormData } from "Shared/helpers";
import { selectUser } from "../select/user.select";
import { userActions } from "../slice/user.slice";

function* getUserWorker() {
	try {
		const token = yield select(selectUser.token);
		const headers = yield call(getReqHeader);
		const { data: user } = yield call(api.get, "/user/profile", headers);
		yield put(userActions.set({ token, user }));
	} catch (error) {
		console.error("getUserWorker", error);
		yield put(userActions.set({ token: "", user: null }));
	}
}

export function* watchUser() {
	yield takeEvery(userActions.get, getUserWorker);
}
